// extracted by mini-css-extract-plugin
module.exports = {"textArea":"autoresize-textarea_textArea_3_C","sizeSmall":"autoresize-textarea_sizeSmall_3FG","sizeMedium":"autoresize-textarea_sizeMedium_1C2"};